<template>
    <div class="warning">
        <vue-headful :title="$t('sh060.labels.erMessgCart2')"/>
        <div><message/></div>
        <div class="mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-3"></div>
                    <div class="col-sm-12 col-md-6 border-warning">
                        <div class="row mt-2 mb-1">
                            <!-- 注文データ取得エラー -->
                            <h2 style="color:#a60000;">{{$t('sh060.labels.erMessgCart1')}}</h2>
                        </div>
                        <div class="row mb-1">
                            <p style="color:#ff0000;font-weight:bold;" v-html="$t('sh060.labels.erMessgCart2')">
								<!-- 注文データの取得にてエラーが発生しました。<br>
								TOPページより再度ご注文の手続きをお願いします。 -->
							</p>
                        </div>
                        <div class="row mb-1">
                            <!-- トップページへ -->
                            <a href @click="gotoTop()">{{$t('sh060.buttons.topPage')}}</a>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
    name: "Warning",
    data() {
        return {
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
    },
    methods: {
        gotoTop: function(){
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query:{pageNo:1}});
        }
    }
}
</script>